const LoggedInLayout = () => import("../../views/LoggedInLayout.vue");

const EdaAnalysis = r => require.ensure([], () => r(require('./views/Index.vue')));
const EDAAnalysisDataProcess = r => require.ensure([], () => r(require('./views/EdaAnalysisProcess.vue')));
const DataProcess = r => require.ensure([], () => r(require('./views/GotoNextStep.vue')));

const moduleRoute = {
  path: "/",
  component: LoggedInLayout,
  children: [
    
    {
      path: "/edaanalysis",
      component: EdaAnalysis
    },
    {
      path: "/dataprocess",
      component: DataProcess
    }
    ,
    {
      path: "/edaprocess",
      component: EDAAnalysisDataProcess
    }
  ]
};

export default router => {
  router.addRoutes([moduleRoute]);
};
